export const LOAD_OUTSTANDING_ORDER = 'LOAD_OUTSTANDING_ORDER';
export const LOAD_OUTSTANDING_ORDER_SUCCESS = 'LOAD_OUTSTANDING_ORDER_SUCCESS';
export const LOAD_OUTSTANDING_ORDER_FAILURE = 'LOAD_OUTSTANDING_ORDER_FAILURE';
export const GET_ALL_BM='GET_ALL_BM';
export const GET_ALL_BM_SUCCESS='GET_ALL_BM_SUCCESS';
export const GET_ALL_BM_FAILURE='GET_ALL_BM_FAILURE';
export const LOAD_LMTMODIFYPOPUP_FLAG='LOAD_LMTMODIFYPOPUP_FLAG';
export const CHANGE_COMMDTY = 'CHANGE_COMMDTY';

// OCO order constants
export const GET_OCO_ORD_DET = 'GET_OCO_ORD_DET';
export const GET_OCO_ORD_DET_SUCCESS = 'GET_OCO_ORD_DET_SUCCESS';
export const GET_OCO_ORD_DET_FAILURE = 'GET_OCO_ORD_DET_FAILURE';

// OTO order constants
export const GET_OTO_ORD_DET = 'GET_OTO_ORD_DET';
export const GET_OTO_ORD_DET_SUCCESS = 'GET_OTO_ORD_DET_SUCCESS';
export const GET_OTO_ORD_DET_FAILURE = 'GET_OTO_ORD_DET_FAILURE';
